import React, { useState } from "react";
import axios from "axios";
import Loading from "../Common/Loading";
import { useRouteMatch, useHistory } from "react-router-dom";
import { getCurrencyNameAndIcon } from "../Common/getCurrencynameAndIcon";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles(() => ({
  card: {
    margin: "10px 10px",
    //padding: 10,
  },
  image: {
    height: 30,
    objectFit: "contain",
    marginRight: 10,
  },
}));

export default function CurrencyList({ setCurrentPath }) {
  const [data, setData] = useState([]);
  const classes = useStyles();
  const match = useRouteMatch();
  const history = useHistory();

  React.useEffect(() => {
    setCurrentPath(match.path);
    axios
      .get("https://crypto-prediction-nac.herokuapp.com/currency-list")
      .then((res) => {
        //console.log("got data: ", res.data.data);
        setData(res.data.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleClick = (cname) => {
    history.push(`/currency/${cname}`);
  };

  if (data.length === 0) return <Loading />;

  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid>
          {data.length > 0 &&
            data.map((coin) => {
              const coinInfo = getCurrencyNameAndIcon(
                coin.currency.toLowerCase()
              );
              //console.log("got coininfo", coinInfo);
              return (
                <Card
                  variant="outlined"
                  key={coin.currency}
                  className={classes.card}
                  onClick={() => handleClick(coin.currency.toLowerCase())}
                >
                  <CardContent>
                    <Grid container>
                      <Grid item sm={4} xs={12} container alignItems="center">
                        {coinInfo !== undefined && (
                          <img
                            className={classes.image}
                            src={coinInfo.icon}
                            alt=""
                          />
                        )}
                        {coinInfo !== undefined && (
                          <Typography variant="subtitle1">
                            {coinInfo.name}
                          </Typography>
                        )}
                        <Typography variant="h6" style={{ marginLeft: "auto" }}>
                          {coin.value}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={8}
                        xs={12}
                        container
                        justifyContent="space-around"
                        alignItems="center"
                      >
                        <Grid>
                          <Typography variant="caption" color="textSecondary">
                            min
                          </Typography>
                          <Typography variant="body1">
                            {coin.minprice}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography variant="caption" color="textSecondary">
                            max
                          </Typography>
                          <Typography variant="body1">
                            {coin.maxprice}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography variant="caption" color="textSecondary">
                            market cap
                          </Typography>
                          <Typography variant="body1">
                            {coin.market_cap}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography variant="caption" color="textSecondary">
                            volume
                          </Typography>
                          <Typography variant="body1">{coin.volume}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              );
            })}
        </Grid>
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
